import SectionHeader from "./SectionHeader";

const features = [
  {
    icon: "ri-focus-3-line",
    title: "追更列表自动提醒",
    desc: "把正在追的作品一键加入列表，更新到最新话时顶部自动标记，打开就知道本期更新到哪一话。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-flashlight-line",
    title: "最新话即时同步",
    desc: "热门韩漫最新话与连载进度实时同步，新作上线即时标记，追更进度永远走在最前面。",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-calendar-check-line",
    title: "每周更新排期",
    desc: "清晰的周更进度表，一目了然每部作品的更新日与更新时间，提前安排你的追更日程。",
    tone: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-check-double-line",
    title: "连载状态标记",
    desc: "连载中、即将完结、已完结状态一目了然，完结作品自动从追更提醒中移除，不再重复打扰。",
    tone: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-fire-line",
    title: "热门连载榜单",
    desc: "基于真实追更热度与读者反馈生成热门连载，第一时间发现同好都在追的爆款韩漫。",
    tone: "bg-accent-100 text-accent-700",
  },
  {
    icon: "ri-user-follow-line",
    title: "个人追更管理",
    desc: "按题材、连载状态分类整理你的追更列表，随时查看进度、快速跳转到最新一话。",
    tone: "bg-secondary-100 text-secondary-700",
  },
];

export default function TrackingFeature() {
  return (
    <section id="tracking" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="追更功能"
          title="追更提醒，不再错过任何一话"
          desc="围绕韩漫追更场景打造的一站式进度工具，从同步、提醒到排期，帮你把连载进度管理得明明白白。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="group rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1"
            >
              <span className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${f.tone}`}>
                <i className={`${f.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-bold text-foreground-950 md:text-lg">{f.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}